(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/pay-lyckoplatsen/assets/javascripts/logger-pay-lyckoplatsen.js') >= 0) return;  svs.modules.push('/components/tur/pay-lyckoplatsen/assets/javascripts/logger-pay-lyckoplatsen.js');
"use strict";


setGlobal('svs.tur.pay_lyckoplatsen.logger', new svs.core.log.Logger('tur:pay-lyckoplatsen'));

 })(window);